import React, { useEffect, useState } from 'react'
import classNames from 'classnames/bind'

import Style from './ResidentAuthHeader.module.scss'

import IconClose from '@Ui/images/myhouse/IconClose'
import IconPrev from '@Ui/images/myhouse/IconPrev'

const cx = classNames.bind(Style)

type Props = {
  onPrevClick?: (evt: React.SyntheticEvent) => void
  onCloseClick?: (evt: React.SyntheticEvent) => void
}
const ResidentAuthHeader = ({ onPrevClick, onCloseClick }: Props) => {
  const [isScrollTop, setIsScrollTop] = useState(window.scrollY <= 5)

  const scrollListener = () => {
    setIsScrollTop(window.scrollY <= 5)
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollListener)
    return () => {
      window.removeEventListener('scroll', scrollListener)
    }
  }, [])

  return (
    <header className={cx('article', !isScrollTop && 'type_fixed')}>
      <div className={cx('inner')}>
        <h1 className={cx('blind')}>우리집</h1>
        {onPrevClick && (
          <button type="button" className={cx('button-action', 'back')} onClick={onPrevClick}>
            <span className={cx('blind')}>이전 페이지</span>
            <span className={cx('icon')}>
              <IconPrev width={24} height={24} />
            </span>
          </button>
        )}
        <button type="button" className={cx('button-action', 'close')} onClick={onCloseClick}>
          <span className={cx('blind')}>닫기</span>
          <span className={cx('icon')}>
            <IconClose width={24} height={24} />
          </span>
        </button>
      </div>
    </header>
  )
}

export default ResidentAuthHeader
